import { render, staticRenderFns } from "./NotificationCardDetails.vue?vue&type=template&id=f8888018&scoped=true&"
import script from "./NotificationCardDetails.vue?vue&type=script&lang=ts&"
export * from "./NotificationCardDetails.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationCardDetails.vue?vue&type=style&index=0&id=f8888018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8888018",
  null
  
)

export default component.exports